import React from 'react';
import LegalLayout, {
    Section,
    Bullets,
    Strong,
    Mail,
} from '@/components/legal/LegalLayout';

export default function TermsOfUse() {
    return (
        <LegalLayout title="Terms of Use" updated="June 20, 2026">
            <Section n={1} title="Acceptance of Terms">
                <p>
                    By downloading or using HyperTroop Fitness Tracker ("the
                    app"), you agree to these Terms of Use. If you do not
                    agree, do not use the app. These terms constitute a binding
                    agreement between you and the developer of HyperTroop ("we",
                    "us").
                </p>
            </Section>

            <Section n={2} title="Eligibility">
                <p>
                    You must be{' '}
                    <Strong>18 years of age or older</Strong> to use the app.
                    By using the app, you represent and warrant that you meet
                    this requirement.
                </p>
            </Section>

            <Section n={3} title="Health Disclaimer">
                <p>
                    HyperTroop is a personal fitness tracking tool. It is{' '}
                    <Strong>not</Strong> a medical device, and nothing in the
                    app constitutes medical advice, diagnosis, or treatment.
                    Consult a qualified healthcare professional before starting
                    any exercise or diet programme, particularly if you have a
                    medical condition or injury. You use the app and act on any
                    information it displays entirely at your own risk.
                </p>
            </Section>

            <Section n={4} title="Your Account">
                <p>You are responsible for:</p>
                <Bullets
                    items={[
                        'Keeping your password confidential',
                        'All activity that occurs under your account',
                        'Providing accurate information when creating your account and profile',
                    ]}
                />
                <p>
                    You may not share your account or use another person's
                    account without their permission.
                </p>
            </Section>

            <Section n={5} title="Acceptable Use">
                <p>You agree not to:</p>
                <Bullets
                    items={[
                        'Use the app for any unlawful purpose',
                        'Attempt to reverse-engineer, decompile, or tamper with the app',
                        'Exploit any bug or vulnerability in the app',
                        "Interfere with the app's servers or networks",
                    ]}
                />
            </Section>

            <Section n={6} title="User Content">
                <p>
                    You retain ownership of the content you create in the app
                    (exercises, programs, notes). By entering content, you
                    grant us a limited licence to store and display it to you
                    within the app. We do not claim ownership of your data.
                </p>
            </Section>

            <Section n={7} title="Intellectual Property">
                <p>
                    The HyperTroop name, logo, app design, and the built-in
                    exercise library curated by HyperTroop are the property of
                    the developer. You may not reproduce or redistribute them
                    without permission.
                </p>
            </Section>

            <Section n={8} title="Termination">
                <p>
                    We reserve the right to suspend or delete your account if
                    you violate these terms. You may delete your account at any
                    time from <Strong>Settings → Delete Account</Strong>.
                </p>
            </Section>

            <Section n={9} title="Disclaimer of Warranties">
                <p>
                    The app is provided{' '}
                    <Strong>"as is"</Strong> without warranties of any kind,
                    express or implied. We do not guarantee that the app will
                    be error-free, uninterrupted, or suitable for any
                    particular purpose.
                </p>
            </Section>

            <Section n={10} title="Limitation of Liability">
                <p>
                    To the maximum extent permitted by applicable law, we shall
                    not be liable for any indirect, incidental, or
                    consequential damages arising from your use of the app,
                    including but not limited to injury, health consequences,
                    or data loss.
                </p>
            </Section>

            <Section n={11} title="Governing Law">
                <p>
                    These terms are governed by the laws of the{' '}
                    <Strong>Republic of India</Strong>. Any disputes shall be
                    subject to the exclusive jurisdiction of the courts in
                    India.
                </p>
            </Section>

            <Section n={12} title="Changes to These Terms">
                <p>
                    We may update these terms from time to time. Continued use
                    of the app after an update constitutes acceptance. We will
                    update the "Last updated" date when changes are made.
                </p>
            </Section>

            <Section n={13} title="Contact">
                <p>
                    For any questions about these terms, contact:{' '}
                    <Mail>support@hypertroop.fit</Mail>
                </p>
            </Section>
        </LegalLayout>
    );
}
